// extracted by mini-css-extract-plugin
export var icon = "_au-3";
export var subtitle = "_au-2";
export var title = "_au-1";
export var value = "_au-0";